import type { AssignmentsDisplay } from "@/Domain/AssignmentsDisplay";
import { EnumVisitType } from "@/Domain/EnumVisitType";

export const getLastRfrVisitDate = function (assignment: AssignmentsDisplay) {
  const date =
    assignment.LastBilledVisitInfo?.date ?? assignment.LastInspectionInfo?.date;
  if (!date) return "";
  return new Date(date).toLocaleDateString();
};

export const getLastRfrVisitType = function (assignment: AssignmentsDisplay) {
  const visitType = assignment.LastBilledVisitInfo?.date
    ? assignment.LastBilledVisitInfo.type
    : assignment.LastInspectionInfo?.type;
  if (!visitType && visitType != 0) return "";
  return EnumVisitType[visitType].replace(/([A-Z])/g, " $1");
};

export const getLastRfrVisitId = function (assignment: AssignmentsDisplay) {
  return assignment.LastBilledVisitInfo?.date != null
    ? assignment.LastBilledVisitInfo?.visitId
    : assignment.LastInspectionInfo?.visitId ?? -1;
};

export const lastRfrVisitLinkEnabled = function (
  assignment: AssignmentsDisplay
) {
  const lastVisit =
    assignment.LastBilledVisitInfo?.date != null
      ? assignment.LastBilledVisitInfo
      : assignment.LastInspectionInfo;

  const hasInspection =
    lastVisit && lastVisit.visitId == assignment.LastInspectionInfo?.visitId;

  return getLastRfrVisitId(assignment) && hasInspection;
};

export const getLastRfrPlantVisit = function (assignment: AssignmentsDisplay) {
  const lastVisitDate = getLastRfrVisitDate(assignment);
  if (!lastVisitDate) return "";
  return `${lastVisitDate} - ${getLastRfrVisitType(assignment)}${
    assignment.lastBilledVirtualVisit ? ", Virtual" : ""
  }`;
};

export const getMyLastVisitId = function (assignment: AssignmentsDisplay) {
  return assignment.LastBilledVisitInfoRFR?.date != null
    ? assignment.LastBilledVisitInfoRFR?.visitId
    : assignment.LastInspectionInfoRFR?.visitId ?? 0;
};

export const myLastVisitLinkEnabled = function (
  assignment: AssignmentsDisplay
) {
  const lastVisit =
    assignment.LastBilledVisitInfoRFR?.date != null
      ? assignment.LastBilledVisitInfoRFR
      : assignment.LastInspectionInfoRFR;

  const hasInspection =
    lastVisit && lastVisit.visitId == assignment.LastInspectionInfoRFR?.visitId;

  return getMyLastVisitId(assignment) && hasInspection;
};

export const getMyLastVisitDate = function (assignment: AssignmentsDisplay) {
  const date =
    assignment.LastBilledVisitInfoRFR?.date ??
    assignment.LastInspectionInfoRFR?.date;
  if (!date) return "";
  return new Date(date).toLocaleDateString();
};

export const getMyLastVisitType = function (assignment: AssignmentsDisplay) {
  const visitType = assignment.LastBilledVisitInfoRFR?.date
    ? assignment.LastBilledVisitInfoRFR.type
    : assignment.LastInspectionInfoRFR?.type;
  if (!visitType && visitType != 0) return "";
  return EnumVisitType[visitType].replace(/([A-Z])/g, " $1");
};

export const getMyLastPlantVisit = function (assignment: AssignmentsDisplay) {
  const lastVisitDate = getMyLastVisitDate(assignment);
  if (!lastVisitDate) return "NEW";
  return `${lastVisitDate} - ${getMyLastVisitType(assignment)}${
    assignment.lastBilledRfrVirtualVisit ? ", Virtual" : ""
  }`;
};
